import { Typography, Link } from '@mui/material';

export interface LinkableTextProps {
  text: string;
}

export const LinkableText = (props: LinkableTextProps) => {
  const { text } = props;
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Split the string by URLs, keeping the URLs in the result using capturing parentheses
  const parts = text.split(urlRegex);

  return (
    <Typography>
      {parts.map((part, index) => {
        // If the part matches the URL pattern, render a Link component
        if (urlRegex.test(part)) {
          return (
            <Link key={index} href={part} target="_blank" rel="noopener noreferrer">
              {part}
            </Link>
          );
        }
        // Otherwise render text normally
        return part;
      })}
    </Typography>
  );
};
